<template>
  <div>
    <div class="cf-title col-xs-12 bottom-buffer">
      <h1>{{ contactform.contactlabel['contactHeading'] }}</h1>
      <p class="no-margin">{{ contactform.contactlabel['contactFormLabel'] }}</p>
    </div>
    <div class="cf-body col-xs-12 col-md-8 col-md-push-2 col-lg-6 col-lg-push-3">
      <form class="vue-form" @submit.prevent="validateForm" novalidate="true">
        <div class="col-xs-12 form-group">
          <div>
            <label for="subject">{{ contactform.contactlabel['subjectLabel'] }}</label>
            <span class="required">*</span>
          </div>
          <div>
            <select required="required" id="subject" v-model="subject" class="col-xs-12 form-control" v-bind:class="{ 'error': missingSubject && attemptSubmit }" :placeholder="contactform.contactlabel['subjectPlaceholder']">
              <option v-for="contactSubject in contactform.repeat" :key="contactSubject.id" :value="contactSubject['subjects']">
                {{ contactSubject['subjects']}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-xs-12 form-group">
          <div>
            <label for="name">{{ contactform.contactlabel['nameLabel'] }}</label>
            <span class="required">*</span>
          </div>
          <div>
            <input required="required" v-model="name" type="text" id="name" class="col-xs-12 form-control" v-bind:class="{ 'error': (missingName || minCharacters) && attemptSubmit }" :placeholder="contactform.contactlabel['namePlaceholder']">
          </div>
        </div>
        <div class="col-xs-12 form-group">
          <div>
            <label for="email">{{ contactform.contactlabel['emailLabel'] }}</label>
            <span class="required">*</span>
          </div>
          <div>
            <input required="required" v-model="email" type="email" id="email" class="col-xs-12 form-control" v-bind:class="{ 'error': (missingEmail || invalidEmail) && attemptSubmit }" :placeholder="contactform.contactlabel['emailPlaceholder']">
          </div>
        </div>
        <div class="col-xs-12 form-group">
          <div>
            <label for="certnr">{{ contactform.contactlabel['certificateNumberLabel']}}</label>
          </div>
          <div>
            <input name="certnr" v-model="certNr" type="text" id="certnr" class="col-xs-12 form-control" :placeholder="contactform.contactlabel['certificateNumberPlaceholder']">
          </div>
        </div>
        <div class="col-xs-12 form-group">
          <div>
            <label for="message">{{ contactform.contactlabel['messageLabel']}}</label>
            <span class="required">*</span>
          </div>
          <div>
            <textarea required="required" v-model="message" cols="50" rows="10" id="message" class="col-xs-12 form-control" v-bind:class="{ 'error': missingMessage && attemptSubmit }" :placeholder="contactform.contactlabel['messagePlaceholder']"></textarea>
          </div>
        </div>
        <div class="col-xs-12 form-group">
          {{ contactform.contactlabel['mandatoryMarkLabel']}}
        </div>
        <div class="col-xs-12 form-group">
          <input id="btn-contact-submit" type="submit" class="btn btn-primary col-xs-12 col-sm-6 col-sm-push-3" :value="lang.submit">
          <div class="col-sm-6 col-sm-offset-3 col-xs-12 text-center">
            <span id="current-spinner"></span>
          </div>
        </div>
      </form>

      <div class="modal-overlay" @click="closeModalMessage" v-if="formMessageVisible">
      <transition name="fade">
        <dialog class="contact-form-message" ref="contactFormMessage">
          <div class="row contact-form-message-popup">
            <div v-if="errors.length || success">
              <div class="modal-header"><h4>{{ lang.headline_message }}</h4></div>
              <div class="modal-body">
                <div v-if="errors.length">
                  <span v-for="(error, index) in errors" class="alert alert-danger col-xs-12" v-html="error" :key="'error-' + index"></span>
                </div>
                <div v-if="success">
                  <span class="alert alert-success col-xs-12">{{ success }}</span>
                </div>
              </div>
            </div>
          </div>
        </dialog>
      </transition>
    </div>
    </div>
  </div>
</template>

<script>
import {Spinner} from 'spin.js';
import axios from 'axios';

const CONTACT_URL = '/sendContactRequest';

export default {
  props: ['lang','contactform', 'locale'],
  name: "contact-form",
  data() {
    return {
      formMessageVisible: false,
      attemptSubmit: false,
      isAjaxRequest: false,
      processing: false,
      errors: [],
      subject: this.contactform.repeat[0].subjects,
      name: '',
      email: '',
      certNr: '',
      message: '',
      success: null,
      spinner: new Spinner({
        lines: 9,
        length: 10,
        width: 4,
        radius: 3,
        scale: 0.75,
        corners: 1,
        color: '#fff',
        fadeColor: 'transparent',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 60,
        fps: 20,
        zIndex: 2e9,
        className: 'spinner',
        top: '-20px',
        left: '50%',
        shadow: 'none',
        position: 'absolute'
      })
    }
  },
  watch: {
    'isAjaxRequest': function () {
      let currentSpinner = document.getElementById('current-spinner');
      let submitButton = document.querySelector('#btn-contact-submit');
      let colorTurq = '#2f918b';
      let colorWhite = '#fff';
      if (this.isAjaxRequest) {
        submitButton.style.color = colorTurq;
        this.spinner = this.spinner.spin(currentSpinner);
      } else {
        this.spinner.stop();
        submitButton.style.color = colorWhite;
      }
    }
  },
  computed: {
    missingSubject: function () {
      return this.subject === this.contactform.repeat[0].subjects;
    },
    missingName: function () {
      return this.name === '';
    },
    minCharacters: function () {
      return this.name.length <= 3;
    },
    missingEmail: function () {
      return this.email === '';
    },
    invalidEmail: function () {
      return this.validEmail(this.email) === false;
    },
    missingMessage: function () {
      return this.message === '';
    },
  },
  methods: {
    showModalMessage: function () {
      this.formMessageVisible = true;
    },
    closeModalMessage: function () {
      this.formMessageVisible = false;
    },
    validateForm: function (e) {
      this.errors = [];
      this.success = null;
      this.attemptSubmit = true;

      if (this.missingSubject || this.missingName || this.minCharacters || this.missingEmail || this.invalidEmail || this.missingMessage) {
        this.errors.push(this.lang.required_description);
      }

      if (!this.errors.length) {
        this.submitForm();
      } else {
        this.showModalMessage();
      }

      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    submitForm: function () {
      // Terminate the function if an async request is processing
      if (this.processing === true) {
        return;
      }
      // Set the async state
      this.processing = true;
      // Start Spinner
      this.isAjaxRequest = true;

      axios.post(`/${this.locale}${CONTACT_URL}`, {
        subject: this.subject,
        name: this.name,
        email: this.email,
        certNr: this.certNr,
        message: this.message
      }).then(() => {
        this.isAjaxRequest = false;
        // On success reset the state
        this.processing = false;
        // Show Success Message
        this.success = null;
        this.success = this.lang.success_message;
        this.showModalMessage();
        // Reset the Form
        this.resetForm();
      }).catch(() => {
        this.errors = [];
        this.isAjaxRequest = false;
        this.errors.push(this.lang.error_message)
        // On failure reset the state
        this.processing = false;
        // Show Error Message
        this.showModalMessage();
      });
    },
    resetForm: function () {
      this.subject = '0';
      this.name = '';
      this.email = '';
      this.certNr = '';
      this.message = '';

      // Remove class 'error' after reseting the form - IE9 support
      setTimeout(function() {
        var elems = document.querySelectorAll('.error');
        [].forEach.call(elems, function (el) {
          el.className = el.className.replace(/\berror\b/, '');
        });
      }, 100);
    }
  }
}
</script>

<style scoped>
.contact-form-message-popup .alert-danger {
  background-color: #d84c64;
  border-color: #d84c64;
  color: #fff;
}
.contact-form-message-popup .alert-success {
  background-color: #7DBB97;
  border-color: #7DBB97;
  color: #fff;
}
.contact-form-message-popup .alert-danger
/deep/ a {
  font-weight: 600;
  color: #fff;
  text-decoration: underline;
}
.error {
  border-color: #d84c64;
}
.contact-form-message {
  display: block;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  height: auto;
  border: none;
  margin: 0;
  padding: 0;
  text-align: left;
}
.modal-header {
  border-bottom: 1px solid #e5e5e5;
  padding: 15px;
}
.modal-overlay {
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  opacity: 1;
}
</style>
